
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetodarshaninnovacrystabooking() {



    const cardData =
    {
        keyword: 'Pune Darshan Innova Crysta Booking',
        heading: 'Meghana Cab : Pune Darshan Innova Crysta Booking',
        headingDescription: 'Meghana Cab offers Pune Darshan Innova Crysta Booking, crafted for travelers seeking a luxurious, spacious, and personalized sightseeing experience around Pune. Whether you are exploring historical landmarks like Sinhagad Fort and Aga Khan Palace, spiritual spots like Parvati Hill and Osho Ashram, or planning a full-day excursion to scenic locales such as Lavasa or Bhimashankar, our Innova Crysta vehicles ensure comfort and elegance throughout your journey. With plush leather interiors, ample legroom, generous luggage space, air-conditioning, and experienced chauffeurs who double as knowledgeable guides, your day out will be smooth and stress-free. Featuring flexible hourly or full-day rental packages, door-to-door pickup from any location in Pune, GPS-enabled tracking, and 24/7 customer support, Meghana Cab guarantees a tailored, reliable, and truly memorable Pune Darshan experience in style.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "The iconic 18th-century fortification built by Peshwa Baji Rao I in 1732. Although much of it was destroyed by fire in 1828, its grand gateways, fortified walls, fountains, and gardens remain today. It hosts a popular evening light-and-sound show that retells Maratha power struggles and legends."
  },
  {
    "title": "Aga Khan Palace",
    "description": "A majestic Italian-arched palace built in 1892 by Aga Khan III. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Now a museum and memorial with serene gardens and samadhis, it’s a significant site of India’s freedom struggle."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km southwest of the city, this hill fortress sits 1,317 m above sea level. It is famed for the Battle of Sinhagad (1670) led by Tanaji Malusare. The site offers a rewarding trek, panoramic views, historic gates and memorials, and local food stalls at the top."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "A globally renowned wellness retreat spread across lush Koregaon Park. It provides meditation sessions, spa treatments, workshops, serene Zen gardens, and swimming facilities—ideal for those seeking relaxation and spiritual rejuvenation."
  },
  {
    "title": "Dagadusheth Halwai Ganapati Temple",
    "description": "A century-old temple dedicated to Lord Ganesha, housing an idol adorned with gold and gems. It is the centerpiece of Pune’s Ganesh Chaturthi celebrations and is known for its vibrant devotional rituals and daily aartis."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century monolithic rock-cut Shiva shrine carved from basalt. It features a circular Nandi mandapa with sixteen pillars and a Shiva-lingam sanctum. Nestled near busy Jangli Maharaj Road, it offers a rare heritage oasis amid urban activity."
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second-highest hill (2,100 ft), with a 103-step climb leading to Peshwa-era shrines of Shiva, Vishnu, and Kartikeya. It includes a small museum and offers stunning sunrise and sunset views over the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Founded in memory of Dinkar Kelkar’s son, this museum houses over 20,000 artifacts—from musical instruments to paintings and toys. With geo-fenced audio guides and themed galleries, it invites visitors into India’s cultural mosaic."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in 1630 for Shivaji Maharaj and his mother Jijabai, Lal Mahal is a reconstructed heritage building featuring murals, life-sized statues, and exhibits detailing Shivaji’s early life and Maratha heritage."
  },
  {
    "title": "Koregaon Park",
    "description": "A leafy, upscale neighborhood known for banyan-lined avenues, art galleries, high-end cafés, microbreweries, and nightlife. Once a quiet residential area, it now blends tranquil greenery with cosmopolitan vibrancy."
  }
],

   "services": [
    {
      "name": "Pune Darshan Innova Crysta Cab Booking",
      "description": "Book a comfortable and spacious Innova Crysta cab for your Pune Darshan tour. Experience hassle-free travel with a professional driver who will take you to all the major sightseeing spots across Pune."
    },
    {
      "name": "Pune Sightseeing Innova Crysta Taxi",
      "description": "Explore Pune’s famous landmarks in style and comfort with our sightseeing Innova Crysta taxis. Visit historical sites, parks, museums, and more with a reliable vehicle and experienced chauffeur."
    },
    {
      "name": "Chauffeur Driven Pune Darshan Innova Crysta",
      "description": "Travel with a courteous, knowledgeable chauffeur who ensures your Pune Darshan trip is safe, convenient, and enjoyable. Benefit from their local expertise to make the most of your visit."
    },
    {
      "name": "Online Pune Darshan Innova Crysta Booking",
      "description": "Book your Pune Darshan Innova Crysta cab online quickly and securely. Get instant confirmation, easy rescheduling, and transparent pricing for a smooth planning experience."
    },
    {
      "name": "Family Pune Darshan Innova Crysta Cab",
      "description": "Perfect for family outings, our Innova Crysta offers ample space and comfort to accommodate your entire family while touring Pune’s attractions with ease."
    },
    {
      "name": "Comfortable Pune Darshan Taxi Innova Crysta",
      "description": "Enjoy a smooth, relaxing ride during your Pune Darshan with our comfortable Innova Crysta taxis. Equipped with air-conditioning and spacious seating to keep you refreshed."
    },
    {
      "name": "Budget Pune Darshan Innova Crysta",
      "description": "Explore Pune without breaking the bank with our budget-friendly Innova Crysta cabs, offering great value without compromising on comfort or service quality."
    },
    {
      "name": "Pune Local Tour Innova Crysta",
      "description": "Discover the hidden gems of Pune with our local tour Innova Crysta service, including city parks, temples, markets, and cultural hotspots, all at your own pace."
    },
    {
      "name": "Religious Tour Innova Crysta Pune Darshan",
      "description": "Plan a religious tour across Pune’s famous temples and spiritual centers in the comfort of our Innova Crysta cab, driven by a courteous chauffeur aware of local customs."
    },
    {
      "name": "AC Innova Crysta Pune Darshan Cab",
      "description": "Stay cool and comfortable throughout your Pune Darshan journey with our fully air-conditioned Innova Crysta cabs, perfect for the warm climate of Pune."
    },
    {
      "name": "Pune Heritage Tour Innova Crysta",
      "description": "Immerse yourself in Pune’s rich heritage by visiting museums, forts, and historical sites in our reliable and spacious Innova Crysta cab."
    },
    {
      "name": "Group Pune Darshan Innova Crysta",
      "description": "Ideal for groups, our Innova Crysta cab provides ample seating and luggage space, making it perfect for group tours and outings in Pune."
    },
    {
      "name": "Private Pune Darshan Cab Innova Crysta",
      "description": "Book a private Innova Crysta cab exclusively for your Pune Darshan trip, ensuring privacy, flexibility, and personalized service throughout the tour."
    },
    {
      "name": "Pune Darshan with Driver Innova Crysta",
      "description": "Enjoy a stress-free Pune Darshan with a professional driver who handles navigation, parking, and local insights, letting you focus fully on your sightseeing experience."
    },
    {
      "name": "Weekend Pune Darshan Innova Crysta",
      "description": "Plan your weekend Pune Darshan with our Innova Crysta cabs, offering comfortable and convenient travel options to explore the city’s top attractions on your days off."
    }
  ],
  "tableData": [
    ["Pune Darshan Innova Crysta Cab Booking", "Pune Sightseeing Innova Crysta Taxi"],
    ["Chauffeur Driven Pune Darshan Innova Crysta", "Online Pune Darshan Innova Crysta Booking"],
    ["Family Pune Darshan Innova Crysta Cab", "Comfortable Pune Darshan Taxi Innova Crysta"],
    ["Budget Pune Darshan Innova Crysta", "Pune Local Tour Innova Crysta"],
    ["Religious Tour Innova Crysta Pune Darshan", "AC Innova Crysta Pune Darshan Cab"],
    ["Pune Heritage Tour Innova Crysta", "Group Pune Darshan Innova Crysta"],
    ["Private Pune Darshan Cab Innova Crysta", "Pune Darshan with Driver Innova Crysta"],
    ["Weekend Pune Darshan Innova Crysta", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Booking for Pune Darshan",
    "WhyChoosedescription": "Explore Pune's rich heritage, modern attractions, and spiritual sites in the comfort of a premium Innova Crysta. Ideal for families, tourists, and corporate guests, our Pune Darshan service offers a seamless sightseeing experience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Travel for the Whole Day",
    "WhyChoosedescription": "Our Innova Crysta cabs come with plush seating, powerful dual AC, and ample legroom—making them perfect for full-day city tours. Enjoy a fatigue-free ride even after visiting multiple destinations across Pune."
  },
  {
    "WhyChooseheading": "Customized Pune Darshan Itinerary",
    "WhyChoosedescription": "Visit top attractions like Shaniwar Wada, Aga Khan Palace, Saras Baug, Parvati Hill, Dagdusheth Temple, and more. Customize your route and timings to match your interests and travel preferences."
  },
  {
    "WhyChooseheading": "Experienced and Knowledgeable Chauffeurs",
    "WhyChoosedescription": "Our drivers are not just skilled at driving—they know the best routes, parking areas, and can guide you through Pune’s top historical and cultural landmarks for a well-paced sightseeing tour."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Travel in a clean, sanitized, and well-maintained Innova Crysta. We ensure high hygiene standards and vehicle reliability, so you can focus on enjoying your Pune city tour."
  },
  {
    "WhyChooseheading": "Flexible Timings and Pickup Options",
    "WhyChoosedescription": "Start your Pune Darshan at your preferred time. We offer door-to-door pickup and drop from your home, hotel, or airport, making your travel totally convenient and personalized."
  },
  {
    "WhyChooseheading": "Transparent Full-Day Rental Pricing",
    "WhyChoosedescription": "We offer fixed packages for Pune Darshan with clear inclusions—driver charges, fuel, and parking fees—so you enjoy your day without worrying about hidden costs or extra charges."
  },
  {
    "WhyChooseheading": "Perfect for Families, Tourists, and Business Guests",
    "WhyChoosedescription": "Whether you're showing Pune to visiting relatives, clients, or enjoying a cultural weekend with your family, our Innova Crysta booking service ensures your city exploration is smooth, stylish, and comfortable."
  }
]






















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta for Pune Darshan?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for hassle-free Pune Darshan Innova Crysta bookings."
    },
    {
        question: "What popular Pune Darshan places can I visit with Innova Crysta?",
        answer: "You can visit places like Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati Temple, Sinhagad Fort, and more comfortably in an Innova Crysta."
    },
    {
        question: "Is the Innova Crysta suitable for sightseeing tours in Pune?",
        answer: "Yes, the spacious and comfortable Innova Crysta is ideal for city tours and sightseeing with family or friends."
    },
    {
        question: "What rental packages are available for Pune Darshan?",
        answer: "We offer hourly packages and full-day rentals customized for Pune Darshan trips."
    },
    {
        question: "Can I request multiple stops during the Pune Darshan tour?",
        answer: "Absolutely! You can request multiple stops for sightseeing, meals, or shopping during the tour."
    },
    {
        question: "Are the vehicles sanitized before Pune Darshan trips?",
        answer: "Yes, all vehicles are cleaned and sanitized thoroughly before every trip."
    },
    {
        question: "Do your drivers assist with local sightseeing information?",
        answer: "Yes, our experienced drivers can guide you about popular spots and local insights during your Pune Darshan."
    },
    {
        question: "Can I hire an Innova Crysta for half-day or full-day Pune Darshan?",
        answer: "Yes, both half-day and full-day booking options are available based on your preference."
    },
    {
        question: "Is fuel and driver included in the Pune Darshan rental fare?",
        answer: "Yes, rental charges include fuel, driver allowance, and applicable taxes."
    },
    {
        question: "What payment methods do you accept for Pune Darshan bookings?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta for Pune Darshan, and the experience was excellent. Comfortable vehicle and knowledgeable driver.”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Perfect service for a sightseeing tour in Pune. The Innova Crysta was spacious and the driver was very courteous.”',
    },
];


































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneDarshanInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune Darshan Innova Crysta Booking",
  "description": "Book Innova Crysta for Pune Darshan sightseeing tours. Comfortable, chauffeur-driven AC taxis for local city tours, family travel, group heritage trips, and religious tours in Pune.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Local Sightseeing Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-darshan-innova-crysta-cab-booking"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune Darshan Innova Crysta Cab | Sightseeing Taxi Booking</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta for Pune Darshan. Explore Pune’s local attractions, heritage sites, and religious places in comfortable AC cabs. Ideal for family and group tours."
  />
  <meta
    name="keywords"
    content="Pune Darshan Innova Crysta Cab Booking, Pune Sightseeing Innova Crysta Taxi, Chauffeur Driven Pune Darshan Innova Crysta, Online Pune Darshan Innova Crysta Booking, Family Pune Darshan Innova Crysta Cab, Comfortable Pune Darshan Taxi Innova Crysta, Budget Pune Darshan Innova Crysta, Pune Local Tour Innova Crysta, Religious Tour Innova Crysta Pune Darshan, AC Innova Crysta Pune Darshan Cab, Pune Heritage Tour Innova Crysta, Group Pune Darshan Innova Crysta, Private Pune Darshan Cab Innova Crysta, Pune Darshan with Driver Innova Crysta, Weekend Pune Darshan Innova Crysta"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneDarshanInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetodarshaninnovacrystabooking;